import { KRUMAGO } from '../../../s3-assets/Krumago';

const GroomingTechnicalAndSoftSkills = () => {
  return (
    <section style={{ padding: '4rem 2rem', backgroundColor: '#ffffff', position: 'relative' }}>
      <div style={{ position: 'relative', width: '100%', overflow: 'hidden', marginBottom: '4rem' }}>
        <img loading="lazy"
          src={KRUMAGO.IMAGES.GROOMING}
          alt="Bridging The Knowledge Gap"
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
            display: 'block'
          }}
        />
        <div style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '50%',
          height: '100%',
          padding: '2rem',
          color: '#ffffff',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}>
          <div style={{
            width: '100%',
            padding: '2rem',
            boxSizing: 'border-box',
            textAlign: 'left',
          }}>
            <h2 style={{
              fontSize: '3.2rem',
              fontWeight: '700',
              color: '#455173',
              fontFamily: 'Poppins, sans-serif',
              margin: '0 0 1rem 0'
            }}>
              Grooming technical and soft skills  </h2>
            <br />
            <h2 style={{
              fontSize: '1.1rem',
              fontWeight: '700',
              fontFamily: 'Poppins, sans-serif',
              margin: '0',
              maxWidth: '100%',
              color: '#bb4c00',
              lineHeight: '1.5',
              textAlign: 'justify'
            }}>
              At AVPS Academy, we believe that a successful IT professional needs more than just technical knowledge. That's why we've designed our curriculum to not only equip you with in-demand technical skills but also to hone your soft skills, making you a well rounded and industry-ready talent.
            </h2>
          </div>
        </div>
      </div>
      <div style={{ maxWidth: '100%', margin: '0 auto', textAlign: 'left' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '3rem' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', maxWidth: '100%', margin: '0 auto', textAlign: 'left' }}>
            <h2 style={{
              fontSize: '4.5rem',
              fontWeight: '700',
              color: 'var(--education-secondary, #3B9394)',
              fontFamily: 'Poppins, sans-serif',
              margin: '0'
            }}>
              Your Path to IT Success
            </h2>
            <h2 style={{
              fontSize: '1.4rem',
              fontWeight: '700',
              fontFamily: 'Poppins, sans-serif',
              margin: '0 0 0 0.5rem',
              maxWidth: '100%',
            }}>
              <span style={{ color: 'var(--education-primary, #746EAC)' }}>AVPS Academy</span>  Master Technical Expertise and Develop Essential Soft Skills
            </h2>
            <h2 style={{
              fontSize: '1.4rem',
              fontWeight: '700',
              fontFamily: 'Poppins, sans-serif',
              margin: '0 auto',
              textAlign: 'center',
              maxWidth: '100%',
            }}>
              Our comprehensive approach focuses on</h2>
          </div>
        </div>
      </div>
      <div style={{ maxWidth: '100%', margin: '0 auto', textAlign: 'left' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '2rem',
          padding: '2rem',
          boxSizing: 'border-box',
          marginBottom: '4rem'
        }}>
          {[
            'Core Technical Skills: Build a strong foundation in your chosen IT specialization.',
            'Hands-On Experience: Apply theoretical knowledge through practical projects and simulations.',
            'Emerging Technologies: Stay updated with the latest industry trends and advancements.',
            'Soft Skill Development: Enhance communication, teamwork, problem-solving, and leadership abilities.'
          ].map((content, index) => (
            <div key={index} style={{
              width: '100%',
              maxWidth: '300px',
              padding: '1.5rem',
              borderRadius: '12px',
              backgroundColor: '#FFFFFF',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              transition: 'box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
              border: '1px solid #ddd',
            }}
              onMouseOver={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.3)';
                e.currentTarget.style.transform = 'translateY(-5px)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <h3 style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                color: 'var(--education-primary, #746EAC)',
                marginBottom: '1rem',
                textAlign: 'center',
                width: '100%',
              }}>
                {[
                  'Core Technical Skills',
                  'Hands-On Experience',
                  'Emerging Technologies',
                  'Soft Skill Development'
                ][index]}
              </h3>
              <p style={{
                fontSize: '1rem',
                color: '#555',
                lineHeight: '1.5',
                textAlign: 'center',
                width: '100%',
              }}>
                {content}
              </p>
            </div>
          ))}
        </div>
        <div style={{
          position: 'relative',
          backgroundImage: `url(${KRUMAGO.IMAGES.HOW_IT_WORKS})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '4rem 2rem',
          color: '#FFFFFF',
          textAlign: 'center',
          marginBottom: '4rem',
        }}>
          <div style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            zIndex: '2',
            backgroundColor: '#f9f9f9',
            padding: '1rem 2rem',
            borderRadius: '8px',
            transform: 'translateY(-2rem)',
          }}>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: '700',
              margin: '0',
              color: 'var(--education-secondary, #3B9394)',
              textAlign: 'center'
            }}>
              Why Soft Skills Matter
            </h2>
          </div>
          <div style={{
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '1',
          }} />
          <div style={{
            position: 'relative',
            zIndex: '2',
            marginTop: '6rem'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-around',
              flexWrap: 'wrap',
              gap: '2rem',
            }}>
              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '300px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: '#FFD700',
                }}>Build Strong Relationships</h3>
                <p style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  Collaborate effectively with colleagues and clients.
                </p>
              </div>
              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '300px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: '#FFD700',
                }}>Communicate Clearly</h3>
                <p style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  Articulate complex technical concepts to both technical and non-technical audiences.
                </p>
              </div>
              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '300px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: '#FFD700',
                }}>Solve Problems Creatively</h3>
                <p style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  Think outside the box to find innovative solutions.
                </p>
              </div>
              <div style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                borderRadius: '12px',
                width: '100%',
                maxWidth: '300px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: '#FFD700',
                }}>Lead with Confidence</h3>
                <p style={{ fontSize: '1rem', color: '#FFFFFF' }}>
                  Take ownership of projects and inspire your team.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style={{
          padding: '4rem 2rem',
          backgroundColor: '#ffffff',
          textAlign: 'left',
        }}>
          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            marginBottom: '3rem',
            color: 'var(--education-secondary, #3B9394)',
          }}>
            How We Do It
          </h2>
          <div style={{ backgroundColor: '#f7f7f7', padding: '2rem 0' }}>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '2rem',
              flexWrap: 'wrap',
            }}>
              <div style={{
                background: 'linear-gradient(45deg, #6a11cb 0%, #2575fc 100%)',
                padding: '3rem 1.5rem',
                clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                color: '#fff',
                width: '220px',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  marginBottom: '1rem',
                }}>Integrated Curriculum</h3>
                <p style={{ fontSize: '1rem' }}>
                  Soft skills are seamlessly integrated into technical courses.
                </p>
              </div>
              <div style={{
                background: 'linear-gradient(45deg, #f12711 0%, #f5af19 100%)',
                padding: '3rem 1.5rem',
                clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                color: '#fff',
                width: '220px',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  marginBottom: '1rem',
                }}>Dedicated Soft Skills Workshops</h3>
                <p style={{ fontSize: '1rem' }}>
                  Enhance specific soft skills through focused training sessions.
                </p>
              </div>
              <div style={{
                background: 'linear-gradient(45deg, #6a11cb 0%, #2575fc 100%)',
                padding: '3rem 1.5rem',
                clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                color: '#fff',
                width: '220px',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  marginBottom: '1rem',
                }}>Real-World Projects</h3>
                <p style={{ fontSize: '1rem' }}>
                  Apply soft skills in collaborative project environments.
                </p>
              </div>
              <div style={{
                background: 'linear-gradient(45deg, #f12711 0%, #f5af19 100%)',
                padding: '3rem 1.5rem',
                clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                color: '#fff',
                width: '220px',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s ease',
              }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  marginBottom: '1rem',
                }}>Mentorship and Coaching</h3>
                <p style={{ fontSize: '1rem' }}>
                  Receive personalized guidance on skill development.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', marginBottom: '3rem' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', maxWidth: '100%', margin: '0 auto', textAlign: 'left' }}>
            <h2 style={{
              fontSize: '1.3rem',
              fontWeight: '700',
              fontFamily: 'Poppins, sans-serif',
              margin: '0 0 0 0.5rem',
              maxWidth: '100%',
            }}>
              <span style={{ color: 'var(--education-primary, #746EAC)' }}>AVPS Academy</span> By choosing AVPS Academy, you're investing in a holistic education that prepares you for a successful IT career.
            </h2>
            <h2 style={{
              fontSize: '1.3rem',
              fontWeight: '700',
              fontFamily: 'Poppins, sans-serif',
              margin: '0 auto',
              textAlign: 'center',
              maxWidth: '100%',
            }}>
              Our focus on both technical and soft skills ensures that you'll be well-equipped to excel in any role.
            </h2>
          </div>
        </div>
        <section style={{ backgroundColor: 'white', padding: '4rem 2rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ flex: 1, marginRight: '2rem' }}>
              <img loading="lazy"
                src={KRUMAGO.IMAGES.ENROLL_NOW}
                alt="enroll"
                style={{ width: '70%', borderRadius: '8px' }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <p data-aos="fade-up" className="text-lg" style={{ color: 'var(--education-secondary, #3B9394)', fontWeight: 'bold', fontSize: '1.5rem' }}>
                Would you like to focus on IT field and soft skill development?
              </p>
              <br />
            <button
  onClick={() => window.location.href = '/products'}
  style={{
    padding: '1rem 2rem',
    backgroundColor: 'var(--education-primary, #746EAC)',
    color: '#fff',
    borderRadius: '12px',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    display: 'block',
    marginTop: '1rem',
    position: 'relative',
    zIndex: 10
  }}
>
  Enroll Now
</button>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};

export default GroomingTechnicalAndSoftSkills;